/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SbbInput } from './input';

@NgModule({
  declarations: [SbbInput],
  imports: [CommonModule],
  exports: [SbbInput],
})
export class SbbInputModule {}
